import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { PiCalendarDuotone, PiListChecksDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

export const SubmenuPermitPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Perizinan",
    });
  }, [setHeader]);
  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.PERMIT_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <PiCalendarDuotone
              className="card-icon tw-text-[#ff6b6b]"
              // style={{ background: "#f7dbd9" }}
            />
            <div className="card-name">Request</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
            className="tw-m-0"
          >
            <PiListChecksDuotone
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="card-name">Laporan</div>
          </div>
        </div>
      </div>
    </div>
  );
};
